// larkite-firebase.js - Firebase Integration for Shopify Theme
// Initializes Firebase and provides authentication/data access functions

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAksgliaOi4hXXK5v_c5_nhOgMYXIbpw0c",
  authDomain: "pushtoapp-95557.firebaseapp.com",
  projectId: "pushtoapp-95557",
  storageBucket: "pushtoapp-95557.firebasestorage.app",
  messagingSenderId: "723294881875",
  appId: "1:723294881875:web:87b6cd3f7e7576d73a5ea6"
};

// Initialize Firebase
let app, auth, db;
let currentUser = null;

// Initialize Firebase when DOM is ready
async function initializeFirebase() {
  try {
    // Import Firebase modules from CDN
    const { initializeApp } = await import('https://www.gstatic.com/firebasejs/10.7.1/firebase-app.js');
    const { getAuth, signInWithEmailAndPassword, onAuthStateChanged } = await import('https://www.gstatic.com/firebasejs/10.7.1/firebase-auth.js');
    const { getFirestore, doc, getDoc, collection, query, where, getDocs, orderBy, limit } = await import('https://www.gstatic.com/firebasejs/10.7.1/firebase-firestore.js');

    // Initialize Firebase app
    app = initializeApp(firebaseConfig);
    auth = getAuth(app);
    db = getFirestore(app);

    console.log('âœ… Firebase initialized successfully');

    // Listen for auth state changes
    onAuthStateChanged(auth, (user) => {
      currentUser = user;
      if (user) {
        console.log('âœ… User authenticated:', user.email);
        // Trigger custom event for dashboard to reload data
        window.dispatchEvent(new CustomEvent('firebase-auth-changed', { detail: { user } }));
      } else {
        console.log('âš ï¸ User not authenticated');
      }
    });

    return { success: true };
  } catch (error) {
    console.error('âŒ Firebase initialization error:', error);
    return { success: false, error: error.message };
  }
}

// Sign in with email and password
async function signInUser(email, password) {
  try {
    const { signInWithEmailAndPassword } = await import('https://www.gstatic.com/firebasejs/10.7.1/firebase-auth.js');
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    console.log('âœ… User signed in:', userCredential.user.email);
    return { success: true, user: userCredential.user };
  } catch (error) {
    console.error('âŒ Sign in error:', error);
    return { success: false, error: error.message };
  }
}

// Get current user's data from Firestore
async function getUserData() {
  if (!currentUser) {
    console.warn('âš ï¸ No user authenticated');
    return null;
  }

  try {
    const { doc, getDoc } = await import('https://www.gstatic.com/firebasejs/10.7.1/firebase-firestore.js');
    const userDoc = doc(db, 'users', currentUser.uid);
    const snapshot = await getDoc(userDoc);

    if (snapshot.exists()) {
      const data = snapshot.data();
      console.log('âœ… User data loaded:', data);
      return data;
    } else {
      console.warn('âš ï¸ User document not found');
      return null;
    }
  } catch (error) {
    console.error('âŒ Error loading user data:', error);
    return null;
  }
}

// Get user's recent credit history
async function getCreditHistory(limitCount = 10) {
  if (!currentUser) {
    return [];
  }

  try {
    const { collection, query, where, orderBy, limit, getDocs } = await import('https://www.gstatic.com/firebasejs/10.7.1/firebase-firestore.js');

    const historyRef = collection(db, 'creditHistory');
    const q = query(
      historyRef,
      where('userId', '==', currentUser.uid),
      orderBy('timestamp', 'desc'),
      limit(limitCount)
    );

    const snapshot = await getDocs(q);
    const history = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));

    console.log(`âœ… Loaded ${history.length} credit history items`);
    return history;
  } catch (error) {
    console.error('âŒ Error loading credit history:', error);
    return [];
  }
}

// Check if user is authenticated
function isUserAuthenticated() {
  return currentUser !== null;
}

// Get current user email
function getCurrentUserEmail() {
  return currentUser ? currentUser.email : null;
}

// Sign out
async function signOutUser() {
  try {
    const { signOut } = await import('https://www.gstatic.com/firebasejs/10.7.1/firebase-auth.js');
    await signOut(auth);
    currentUser = null;
    console.log('âœ… User signed out');
    return { success: true };
  } catch (error) {
    console.error('âŒ Sign out error:', error);
    return { success: false, error: error.message };
  }
}

// Export functions for global use
window.LarkiteFirebase = {
  initializeFirebase,
  signInUser,
  signOutUser,
  getUserData,
  getCreditHistory,
  isUserAuthenticated,
  getCurrentUserEmail
};

// Auto-initialize when script loads
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeFirebase);
} else {
  initializeFirebase();
}